import React from 'react';
import { ActionButton } from '../ActionButton';
import { FOREST_GREEN, MID_GRAY } from '@/styles/tokens';
import type { PropertyMessage } from '../../types';

const COLORS: [string, string][] = [
  ['red', '#EF4444'], ['blue', '#3B82F6'], ['green', '#22C55E'], ['yellow', '#EAB308'], ['orange', '#F97316'],
  ['purple', '#A855F7'], ['pink', '#EC4899'], ['black', '#000000'], ['white', '#FFFFFF'], ['gray', '#6B7280'],
];

interface PinColorDrilldownProps {
  onAutoSend: (command: string) => void;
  onPreFill: (text: string) => void;
  onInjectMessage: (content: string) => void;
  onDone: () => void;
}

export const PinColorDrilldown: React.FC<PinColorDrilldownProps> = ({
  onAutoSend,
  onPreFill,
  onInjectMessage,
  onDone,
}) => (
  <>
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '8px 0' }}>
      <ActionButton variant="back" onClick={onDone}>
        ← Back
      </ActionButton>
      <span style={{ fontSize: '13px', color: MID_GRAY.DEFAULT }}>Choose a color:</span>
    </div>
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', alignItems: 'center' }}>
      {COLORS.map(([name, hex]) => (
        <button
          key={name}
          title={name}
          onClick={() => {
            onAutoSend(`make pin ${name}`);
            onDone();
          }}
          style={{
            width: 28,
            height: 28,
            borderRadius: '6px',
            border: name === 'white' ? '1px solid #D1D5DB' : '1px solid transparent',
            backgroundColor: hex,
            cursor: 'pointer',
            transition: 'transform 150ms ease, box-shadow 150ms ease',
            padding: 0,
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.15)';
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = 'none';
          }}
        />
      ))}
      <button
        onClick={() => {
          onDone();
          onPreFill('set pin color to ');
          onInjectMessage('Type a color name or hex code (e.g., #FF5733) and press Enter.');
        }}
        style={{
          width: 28,
          height: 28,
          borderRadius: '6px',
          border: '1px dashed rgba(47, 133, 90, 0.4)',
          backgroundColor: 'transparent',
          cursor: 'pointer',
          transition: 'all 150ms ease',
          padding: 0,
          fontSize: '14px',
          fontWeight: 600,
          color: FOREST_GREEN.DEFAULT,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        title="Custom color"
        onMouseEnter={(e) => {
          e.currentTarget.style.borderColor = FOREST_GREEN.DEFAULT;
          e.currentTarget.style.backgroundColor = 'rgba(47, 133, 90, 0.08)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.borderColor = 'rgba(47, 133, 90, 0.4)';
          e.currentTarget.style.backgroundColor = 'transparent';
        }}
      >
        #
      </button>
    </div>
  </>
);
